module.exports = __webpack_public_path__ + "static/media/terms.45da52cf.svg";